import { Button, Modal } from 'antd';
import React, { FC } from 'react';

import styles from './ModalFinishForm.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onFinishForm: () => Promise<void>;
  updateUserInfoLoading: boolean;
};

export const ModalFinishForm: FC<Props> = ({
  isOpen,
  onClose,
  onFinishForm,
  updateUserInfoLoading,
}) => {
  return (
    <Modal
      title="Отправка документов на проверку"
      width={400}
      onCancel={onClose}
      open={isOpen}
      footer={null}
    >
      <p className={styles['error-load-doc']}>
        После отправки документов , вы больше не сможете изменить их до
        получения результатов проверки
      </p>
      <div className={styles['buttons-group']}>
        <Button onClick={onClose} htmlType="button">
          Отмена
        </Button>

        <Button
          onKeyDown={(e) => (e.key === 'Enter' ? e.preventDefault() : '')}
          type="primary"
          onClick={onFinishForm}
          loading={updateUserInfoLoading}
        // htmlType="submit"
        >
          Отправить
        </Button>
      </div>
    </Modal>
  );
};
